/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Current_Trip_OrdersInputs */

const vi_vehicle_current_trip_orders = /** @type {(inputs: Vehicle_Current_Trip_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách đơn hàng`)
};

/**

* @param {Vehicle_Current_Trip_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_current_trip_orders = /** @type {((inputs?: Vehicle_Current_Trip_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Current_Trip_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_current_trip_orders(inputs)
});